// extracted by mini-css-extract-plugin
export default {"row2":"ExternalTable_row2__c9N9O","cards":"ExternalTable_cards__K-v1F"};